import { render, staticRenderFns } from "./SamsPayAgent.vue?vue&type=template&id=4f9c2b0e"
import script from "./SamsPayAgent.vue?vue&type=script&lang=js"
export * from "./SamsPayAgent.vue?vue&type=script&lang=js"
import style0 from "./SamsPayAgent.vue?vue&type=style&index=0&id=4f9c2b0e&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports